import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerbg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/jwtXW2Bc6tUEEYtcnIIt/locations/MvLV4OUJjaddWhfyWwXM'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          bg="rgba(200, 190, 120, 0.8)"
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <CFView row center>
            <CFImage h="65px" mv="5px" src={logo} alt="Samurai Sushi Logo" />
          </CFView>
          <LocationSelect />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          bg="transparent"
          zIndex={98}
          bg="rgba(200, 190, 120, 0.8)"
          boxShadow="2px 2px 4px rgba(0,0,0,.5)"
          w="100%"
        >
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            maxWidth="1400px"
            ph="30px"
          >
            <CFView row justifyStart alignCenter mv="1px">
              <CFImage
                h="60px"
                ml="10px"
                src={logo}
                alt="Samurai Sushi Logo"
                zIndex={98}
              />
              <CFSelect selector={dispatch.restaurant.getHasMultipleLocations}>
                <CFView ml="10px" zIndex={99}>
                  <LocationSelect />
                </CFView>
              </CFSelect>
            </CFView>
            {/* <CFView hover mt="12px">
              <CFLink href={orderingUrl}>
                <CFImage
                  h="60px"
                  src={viewMenu}
                  alt="Samurai Sushi View Menu Button"
                />
              </CFLink>
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
